import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { Fn_AddEditData, Fn_DisplayData, Fn_DeleteData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { toast } from "react-toastify";

const FirmTypeSchema = Yup.object().shape({
  Name: Yup.string().required("Firm Type name is required"),
});

const AddEdit_FirmTypeMaster = () => {
  const [state, setState] = useState({
    id: 0,
    formData: {
      Name: "",
      IsNotInUse: false,
    },
    isProgress: false,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const API_URL_SAVE = "FirmTypeMaster/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/FirmTypeMaster/Id`;

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append("Name", values.Name);
      formData.append("IsNotInUse", values.IsNotInUse ? true : false);

      Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVE,
        true,
        "memberid",
        navigate,
        "/FirmTypeMaster"
      );
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Firm Type Master" />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Firm Type Master</h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <Formik
                  initialValues={state.formData}
                  enableReinitialize
                  validationSchema={FirmTypeSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      handleSubmit(values);
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="text-label">Firm Type Name *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="Name"
                            value={values.Name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Enter firm type name"
                          />
                          {errors.Name && <div className="text-danger fs-12">{errors.Name}</div>}
                        </div>

                        <div className="col-md-6 mb-3 d-flex align-items-center mt-4">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="IsNotInUse"
                              name="IsNotInUse"
                              checked={!!values.IsNotInUse}
                              onChange={(e) => setFieldValue("IsNotInUse", e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="IsNotInUse">
                              Not In Use
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="mt-3">
                        <button type="submit" className="btn btn-primary me-2" disabled={isSubmitting}>
                          {isSubmitting ? "Saving..." : "Save"}
                        </button>
                        {state.id > 0 && (
                          <button
                            type="button"
                            className="btn btn-danger me-2"
                            onClick={async () => {
                              if (window.confirm(`Are you sure you want to delete firm type "${values.Name || state.id}"?`)) {
                                try {
                                  await Fn_DeleteData(dispatch, () => {}, Number(state.id), `${API_WEB_URLS.MASTER}/0/token/FirmTypeMaster`);
                                  toast.success("Firm type deleted successfully");
                                  navigate("/FirmTypeMaster");
                                } catch (err) {
                                  console.error("Error deleting firm type:", err);
                                }
                              }
                            }}
                          >
                            Delete
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn btn-danger light"
                          onClick={() => navigate("/FirmTypeMaster")}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddEdit_FirmTypeMaster;
